import React from 'react';

export const PointOfSalesIcon = () => {
  return (
    <svg viewBox="0 0 300 300" className="w-full h-auto">
      <ellipse cx="150" cy="260" rx="140" ry="20" fill="#d1f4f0" opacity="0.5"></ellipse>
      <ellipse cx="150" cy="255" rx="120" ry="15" fill="#b8ede7" opacity="0.6"></ellipse>
      <ellipse cx="150" cy="250" rx="100" ry="10" fill="#9fe6dd" opacity="0.7"></ellipse>
      <rect x="100" y="100" width="120" height="90" rx="6" fill="#7a9ca5"></rect>
      <rect x="105" y="105" width="110" height="80" rx="5" fill="#8fb3bc"></rect>
      <rect x="115" y="115" width="90" height="60" rx="4" fill="#d1e8ed"></rect>
      <path d="M 140 135 L 150 125 L 160 135 L 170 125 L 180 135" stroke="#0d9488" strokeWidth="3" fill="none" strokeLinecap="round" strokeLinejoin="round"></path>
      <circle cx="160" cy="150" r="20" fill="#ffffff" opacity="0.3"></circle>
      <path d="M 145 155 L 155 145 L 165 155 L 175 145 L 185 155" stroke="#0d9488" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" opacity="0.5"></path>
      <rect x="125" y="125" width="15" height="15" rx="2" fill="#ffffff" opacity="0.4"></rect>
      <path d="M 135 127 L 145 127 L 145 137 L 135 137 Z" fill="none" stroke="#0d9488" strokeWidth="2"></path>
      <line x1="140" y1="130" x2="140" y2="134" stroke="#0d9488" strokeWidth="2"></line>
      <line x1="138" y1="132" x2="142" y2="132" stroke="#0d9488" strokeWidth="2"></line>
      <rect x="180" y="160" width="60" height="50" rx="4" fill="#7a9ca5"></rect>
      <rect x="185" y="165" width="50" height="40" rx="3" fill="#8fb3bc"></rect>
      <rect x="190" y="175" width="40" height="3" rx="1.5" fill="#d1e8ed"></rect>
      <rect x="190" y="182" width="40" height="3" rx="1.5" fill="#d1e8ed"></rect>
      <rect x="190" y="189" width="30" height="3" rx="1.5" fill="#d1e8ed"></rect>
      <rect x="190" y="196" width="25" height="3" rx="1.5" fill="#d1e8ed"></rect>
      <circle cx="205" cy="175" r="3" fill="#0d9488"></circle>
      <circle cx="215" cy="175" r="3" fill="#0d9488"></circle>
      <circle cx="225" cy="175" r="3" fill="#0d9488"></circle>
      <circle cx="205" cy="182" r="3" fill="#0d9488"></circle>
      <circle cx="215" cy="182" r="3" fill="#0d9488"></circle>
      <circle cx="225" cy="182" r="3" fill="#0d9488"></circle>
      <circle cx="205" cy="189" r="3" fill="#0d9488"></circle>
      <circle cx="215" cy="189" r="3" fill="#0d9488"></circle>
      <circle cx="205" cy="196" r="3" fill="#0d9488"></circle>
      <circle cx="215" cy="196" r="3" fill="#0d9488"></circle>
      <rect x="110" y="195" width="50" height="35" rx="3" fill="#6b7280"></rect>
      <rect x="115" y="200" width="40" height="25" rx="2" fill="#9ca3af"></rect>
      <circle cx="120" cy="207" r="2" fill="#d1d5db"></circle>
      <circle cx="127" cy="207" r="2" fill="#d1d5db"></circle>
      <circle cx="134" cy="207" r="2" fill="#d1d5db"></circle>
      <circle cx="141" cy="207" r="2" fill="#d1d5db"></circle>
      <circle cx="148" cy="207" r="2" fill="#d1d5db"></circle>
      <circle cx="120" cy="214" r="2" fill="#d1d5db"></circle>
      <circle cx="127" cy="214" r="2" fill="#d1d5db"></circle>
      <circle cx="134" cy="214" r="2" fill="#d1d5db"></circle>
      <circle cx="141" cy="214" r="2" fill="#d1d5db"></circle>
      <circle cx="148" cy="214" r="2" fill="#d1d5db"></circle>
      <circle cx="120" cy="221" r="2" fill="#d1d5db"></circle>
      <circle cx="127" cy="221" r="2" fill="#d1d5db"></circle>
      <circle cx="134" cy="221" r="2" fill="#d1d5db"></circle>
      <circle cx="141" cy="221" r="2" fill="#d1d5db"></circle>
      <circle cx="148" cy="221" r="2" fill="#d1d5db"></circle>
    </svg>
  );
};
